/**
 * Validates if a given file matches the specified accept criteria.
 * This function is typically used for validating file inputs with the `accept` attribute.
 * Example accept values: `.png,.jpg,.svg,.pdf,.jpeg,.HEIC`
 *
 * @param file - The file to be validated.
 * @param accept - A comma-separated string of accepted file types or extensions.
 * @returns `true` if the file matches the accept criteria, otherwise `false`.
 */
export function validateFileAccept(file: File, accept: string): boolean {
	if (!accept) {
		return true;
	}
	const acceptList = accept.split(',');
	const fileType = file.type;
	const fileName = file.name;
	const fileExtension = fileName.split('.').pop();
	return acceptList.some((acceptType) => {
		if (acceptType.startsWith('.')) {
			return fileExtension === acceptType.slice(1);
		}
		return fileType === acceptType;
	});
}
